import RouterViewBody from '~/views/RouterViewBody.vue'

const formatDate = function (date) {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${day}.${month}.${year}`
}

export default [
  {
    path: 'projects',
    name: 'projects',
    component: () => import('~/views/template/ViewsTemplateMain.vue'),
    props: { type: 'projects' },
    redirect: { name: 'Projects' },
    meta: {
      access: { abilities: ['view_projects'] },
      breadCrumbLocalStorage: 'translations',
      breadCrumb: (translation) => translation.pages.pages.buttons.proekty,
    },
    children: [
      {
        path: 'in-work',
        component: RouterViewBody,
        children: [
          {
            path: '',
            name: 'Projects',
            component: () => import('~/views/sales/salesAll.vue'),
            meta: {
              search: true,
              responsive: true,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: ':id',
            component: RouterViewBody,
            meta: {
              breadCrumbGetter: 'workClientProject/workClientProjectShow',
              breadCrumb: (project) => project.name,
            },
            children: [
              {
                path: '',
                name: 'ProjectsProjectShow',
                component: () => import('~/views/sales/salesProjectShow.vue'),
                meta: {
                  responsive: true,
                },
              },
              {
                path: 'edit',
                name: 'ProjectsProjectShowEdit',
                component: () => import('~/views/sales/salesProjectShow.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.common.breadcrumbs['redaktirovanie'],
                  access: { abilities: ['edit_projects'] },
                  responsive: true,
                },
              },
              {
                path: 'project-proposed',
                name: 'ProjectsProjectProposed',
                component: () => import('~/views/sales/salesProjectProposed.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.sales_project.price_offer_terms.title,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'statistics',
        component: RouterViewBody,
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.projects.pages.statistics,
          search: true
        },
        children: [
          {
            path: '',
            name: 'TimeControl',
            component: () => import('~/views/sales/timeControl/timeControl.vue'),
            meta: {
              responsive: true,
              search: true,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: ':id',
            component: RouterViewBody,
            meta: {
              breadCrumbGetter: 'workClientProject/workClientProjectStatistic',
              breadCrumb: (project) => project && project.project && project.project.name,
            },
            children: [
              {
                path: '',
                name: 'timeControlShow',
                component: () => import('~/views/sales/timeControl/timeControlShow.vue'),
                meta: {
                  responsive: true,
                },
              },
              {
                path: 'reports',
                component: RouterViewBody,
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['projects'].pages.reports,
                },
                children: [
                  {
                    path: '',
                    name: 'timeControlShowReports',
                    component: () => import('~/views/sales/timeControl/timeControlShowReports.vue'),
                    meta: {
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                      responsive: true,
                    },
                  },
                  {
                    path: 'free',
                    name: 'timeControlShowReportsFree',
                    component: () =>
                      import('~/views/sales/timeControl/timeControlShowReportsFree.vue'),
                    meta: {
                      access: { userType: 'user' },
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) => translation.pages['projects'].pages.free_report,
                      responsive: true,
                    },
                    children: [
                      {
                        path: 'pdf',
                        name: 'timeControlShowReportsViewFreePdf',
                        meta: {
                          breadCrumb: 'PDF',
                          responsive: true,
                        },
                      },
                    ],
                  },
                  {
                    path: ':report_id',
                    name: 'timeControlShowReportsView',
                    component: () =>
                      import('~/views/sales/timeControl/timeControlShowReportsView.vue'),
                    meta: {
                      access: { userType: 'user' },
                      breadCrumbGetter:
                        'workClientProjectsPeriodReport/workClientProjectsPeriodReportShow',
                      breadCrumb: (report) =>
                        formatDate(report.start_date) + ' - ' + formatDate(report.end_date),
                      responsive: true,
                    },
                    children: [
                      {
                        path: 'pdf',
                        name: 'timeControlShowReportsViewPdf',
                        meta: {
                          responsive: true,
                        },
                      },
                      {
                        path: ':bill',
                        name: 'timeControlShowReportsViewBill',
                        component: () => import('~/views/sales/timeControl/timeControlShowReportsViewBill'),
                        meta: {
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) => translation.pages.finance['invoice-table'].report,
                          responsive: true,
                        },
                      }
                    ],
                  },
                  {
                    path: ':report_id/invoice',
                    name: 'timeControlShowReportsViewCheck',
                    component: () =>
                      import('~/views/sales/timeControl/timeControlShowReportsCheck.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) => translation.pages.projects.reports_table.invoice,
                      responsive: true,
                      access: { abilities: ['view_bills'] },
                    },
                    children: [
                      {
                        path: 'pdf',
                        name: 'timeControlShowReportsViewCheckPdf',
                        component: () =>
                          import('~/views/sales/timeControl/timeControlShowReportsCheck.vue'),
                        meta: {
                          breadCrumb: 'pdf',
                          responsive: true,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: ':employeeId',
                name: 'timeControlShowEmployee',
                component: () => import('~/views/sales/timeControl/timeControlShowEmployee.vue'),
                meta: {
                  responsive: true,
                  breadCrumbGetter: 'employee/employeeReports',
                  breadCrumb: (employee) =>
                    employee && employee.employee && employee.employee.user
                      ? employee.employee.user.first_name + ' ' + employee.employee.user.last_name
                      : '',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'done',
        component: RouterViewBody,
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.projects.pages.archive,
          access: { abilities: ['view_all_client_project'] },
        },
        children: [
          {
            path: '',
            name: 'ProjectsDone',
            component: () => import('~/views/sales/salesAll.vue'),
            meta: {
              paginations: {
                page: 1,
                limit: 10,
              },
              responsive: true,
              search: true,
            },
          },
          {
            path: ':id',
            component: RouterViewBody,
            meta: {
              breadCrumbGetter: 'workClientProject/workClientProjectShow',
              breadCrumb: (project) => project.name,
            },
            children: [
              {
                path: '',
                name: 'ProjectsDoneShow',
                component: () => import('~/views/sales/salesProjectShow.vue'),
                meta: {
                  responsive: true,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'reports',
        component: RouterViewBody,
        meta: {
          access: { abilities: ['view_project_reports'] },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.projects.pages.reports,
        },
        children: [
          {
            path: '',
            name: 'ProjectsReports',
            component: () => import('~/views/sales/salesProjectReports.vue'),
            meta: {
              responsive: true,
              paginations: {
                limit: 10,
                page: 1,
              }
            },
          }
        ]
      }
    ],
  },
]
